import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ExceptionService, UtilsService } from '../../xform-compat';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';
import { EnvironmentConfig } from '../../shared/models/environment-config.interface';

/**
 * Data service that fetches the running environment and its default nav color
 * from the backend. The result is cached for the lifetime of the app so the
 * endpoint is only hit once.
 */
@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService extends RmsBasicCrudService<EnvironmentConfig> {

  private config$: Observable<EnvironmentConfig>;

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Returns the environment config, caching the first response.
   */
  public getEnvironmentConfig(): Observable<EnvironmentConfig> {
    if (!this.config$) {
      this.config$ = super.getData('/api/rms/config/environment').pipe(shareReplay(1));
    }
    return this.config$;
  }
}
